import api from '../config/api'

export const fetchAllAdvertisement = async () => {
  const res = await api.get("/advertisement/");
  return res.data.data;
};

export const fetchAdvertisementById = (id) => {
   const res= api.get(`advertisement/${id}`);
}

export const createAdvertisement = async(formData) => {
  const res = await api
  .post(`/advertisement/`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
return res.data;
}

export const updateAdvertisement = async (id, formData) => {
  const res = await api
    .post(`/advertisement/?id=${id}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  return res.data;
};

export const deleteAdvertisement = async (id) => {
  const res = await api.delete(`/advertisement/?id=${id}`);
  return res.data;
};
